import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

class BasicDatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value ? new Date(this.props.value) : null,
    };
  }

  onChange = (selectedDate) => {
    const { onChange } = this.props;
    this.setState({
      value: selectedDate,
    });
    onChange(selectedDate);
  };

  render() {
    const { minimumDate, disabled } = this.props;
    const { value } = this.state;

    return (
      <DatePicker
        disabled={disabled}
        selected={value}
        onChange={this.onChange}
        minDate={minimumDate}
        customInput={<DatePickerInput value={value} onClick={this.onChange} />}
        shouldCloseOnSelect={true}
      />
    );
  }

}

const DatePickerInput = ({ value, onClick }) => {
  const formatDisplayValue = (val) => {
    if (!val) return 'Select date...';

    // If it's already a string, return it
    if (typeof val === 'string') return val;

    // If it's a Date object, format it
    if (val instanceof Date && !isNaN(val.getTime())) {
      return val.toLocaleDateString();
    }

    // Try to create a Date object from the value
    try {
      const date = new Date(val);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString();
      }
    } catch (e) {
      console.warn('Invalid date value:', val);
    }

    return 'Select date...';
  };

  return (
    <div
      onClick={onClick}
    // style={{
    //   padding: '8px 8px',
    //   backgroundColor: '#fff',
    //   cursor: 'pointer',
    //   display: 'flex',
    //   alignItems: 'center',
    //   justifyContent: 'space-between',
    //   minHeight: '38px',
    //   fontSize: '14px',
    //   color: '#495057'
    // }}
    >
      <span>{formatDisplayValue(value)}</span>
      {/* <i 
        className="fa fa-calendar" 
        style={{ 
          color: '#6c757d',
          marginLeft: '8px'
        }}
      ></i> */}
    </div>
  );
};

export default BasicDatePicker;
